import EmailPulseSummaryCards from '../email-pulse-summary-cards/email-pulse-summary-cards.component';
import { securitySummaryCardsConfig } from './security.config';

/**
 * Security tab summary cards component.
 * Wrapper around the generic EmailPulseSummaryCards with Security-specific configuration.
 */
const SecuritySummaryCards = () => {
  return <EmailPulseSummaryCards config={securitySummaryCardsConfig} />;
};

export default SecuritySummaryCards;
